import { VariantSelectedEvent, VariantUpdateEvent } from '@theme/events';

// Keep the custom radio layout on Horizon's native variant/cart contract.
function initializeProduct(root) {
  if (root.dataset.variantBridge === 'ready') return;
  root.dataset.variantBridge = 'ready';
  const form = root.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;
  const status = root.querySelector('[data-jsx-variant-status]');
  const error = root.querySelector('[data-jsx-variant-error]');
  const retry = root.querySelector('[data-jsx-variant-retry]');
  const buttons = () => [...form.querySelectorAll('button[type="submit"]'), ...document.querySelectorAll(`button[form="${CSS.escape(form.id)}"]`)];
  const express = () => root.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
  let controller;
  let request = 0;
  let blocked = false;

  function lock() {
    blocked = true;
    root.setAttribute('aria-busy', 'true');
    buttons().forEach(button => { button.disabled = true; });
    if (express()) express().hidden = true;
  }

  function updateTotal() {
    const button = root.querySelector('[data-atc-main]');
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    const cents = Number(button?.dataset.cents || 0);
    const value = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: root.dataset.currency || 'USD', maximumFractionDigits: 2,
    }).format(cents * quantity / 100);
    root.querySelectorAll('[data-pick="total"]').forEach(node => { node.textContent = value; });
  }

  form.addEventListener('submit', event => {
    if (blocked) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  form.addEventListener('input', updateTotal);
  form.addEventListener('change', updateTotal);
  root.addEventListener('quantity-selector:update', updateTotal);

  root.addEventListener('change', async event => {
    const radio = event.target.closest('input[type="radio"][data-variant-id]');
    if (!radio || !root.contains(radio)) return;
    const id = radio.dataset.variantId;
    const sequence = ++request;
    controller?.abort();
    controller = new AbortController();
    const url = new URL(root.dataset.productUrl, window.location.origin);
    url.searchParams.set('variant', id);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    retry.href = url.href;
    error.hidden = true;
    status.textContent = root.dataset.variantLoading;
    root.dispatchEvent(new VariantSelectedEvent({ id }));
    lock();
    url.searchParams.set('section_id', root.dataset.sectionId);

    try {
      const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Variant section unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (sequence !== request) return;
      const fresh = html.querySelector('[data-jsx-product]');
      const variant = JSON.parse(html.querySelector('[data-jsx-current-variant]')?.textContent || 'null');
      if (!fresh || fresh.dataset.productId !== root.dataset.productId || String(variant?.id) !== id ||
          html.querySelector('[ref="variantId"]')?.value !== id) throw new Error('Variant section mismatch');

      // Horizon owns the form ID, availability, accelerated checkout and quantity rules.
      root.dispatchEvent(new VariantUpdateEvent(variant, root.dataset.sectionId, {
        html, productId: root.dataset.productId,
      }));
      for (const part of ['meta', 'gallery', 'label']) {
        const current = root.querySelector(`[data-jsx-part="${part}"]`);
        const replacement = fresh.querySelector(`[data-jsx-part="${part}"]`);
        if (current && replacement) current.replaceWith(replacement);
      }
      const quantity = form.querySelector('[name="quantity"]');
      const freshQuantity = fresh.querySelector('[name="quantity"]');
      if (quantity && freshQuantity) {
        quantity.disabled = freshQuantity.disabled;
        const selector = quantity.closest('quantity-selector-component');
        if (selector) selector.dataset.variantId = id;
      }
      root.dataset.available = String(variant.available);
      form.dataset.available = String(variant.available);
      const main = root.querySelector('[data-atc-main]');
      if (main) main.dataset.cents = String(variant.price);
      root.querySelectorAll('[data-pick="sign"]').forEach(node => { node.textContent = radio.dataset.sign; });
      document.querySelectorAll('[data-sticky-atc] [data-pick]').forEach(node => {
        if (radio.dataset[node.dataset.pick] !== undefined) node.textContent = radio.dataset[node.dataset.pick];
      });
      buttons().forEach(button => { button.disabled = !variant.available; });
      if (express()) express().hidden = !variant.available;
      blocked = false;
      root.removeAttribute('aria-busy');
      status.textContent = fresh.querySelector('.jsx-pdp__promise')?.textContent || '';
      updateTotal();
      const address = new URL(window.location.href);
      address.searchParams.set('variant', id);
      window.history.replaceState({}, '', address);
    } catch (failure) {
      if (failure.name === 'AbortError' || sequence !== request) return;
      lock();
      root.removeAttribute('aria-busy');
      status.textContent = '';
      error.hidden = false;
    }
  });
  updateTotal();
}

function initialize(scope = document) {
  scope.querySelectorAll('[data-jsx-product]').forEach(initializeProduct);
}
initialize();
document.addEventListener('shopify:section:load', event => initialize(event.target));
